module.exports = __webpack_public_path__ + "static/media/icon-document.80514081.svg";